import styles from "./styles.module.scss";
import "./pricingTable.css";
import { Table } from "antd";
import { mockData } from "./mock";
import classNames from "classnames";
import { Slider, InputNumber } from "antd";
import { useState } from "react";

const generateColumns = () => {
  const dates = Object.keys(mockData[0]).filter(
    (key) => key !== "key" && key !== "type",
  );
  const columns = [
    {
      title: "",
      dataIndex: "type",
      key: "type",
    },
    ...dates.map((date) => ({
      title: date,
      dataIndex: date,
      key: date,
      render: (text: string) => <span style={{ color: "#fff" }}>{text}</span>,
    })),
  ];
  return columns;
};

const flattenData = (data: any[]) => {
  return data.map((item) => ({
    key: item.key,
    type: item.type,
    ...item,
  }));
};

const Pricing = () => {
  const [activeDiscount, setActiveDiscount] = useState(5);
  const [couponValue, setCouponValue] = useState(0);
  const [priceValue, setPriceValue] = useState(0);

  const handleDiscountClick = (discount: number) => {
    setActiveDiscount(discount);
  };

  const handleCouponChange = (value: number | null) => {
    setCouponValue(value || 0);
  };

  const handlePriceChange = (value: number | null) => {
    setPriceValue(value || 0);
  };

  return (
    <div className={classNames(styles.pricingWrapper, "pricing-table")}>
      <Table
        columns={generateColumns()}
        dataSource={flattenData(mockData)}
        pagination={false}
        scroll={{ x: "max-content" }}
      />
      <div className={styles.priceWrapper}>
        <div className={styles.priceBox}>
          <span>Discount, %</span>
          <div className={styles.sliderContainer}>
            <div className={styles.inputNumberWithIcon}>
              <InputNumber
                min={0}
                max={100}
                value={priceValue}
                onChange={handlePriceChange}
                className={styles.inputField}
                controls={false}
              />
            </div>
            <Slider
              min={0}
              max={100}
              value={priceValue}
              onChange={handlePriceChange}
              className={styles.customSlider}
              railStyle={{
                backgroundColor: "#2e2e2e",
                height: "14px",
                borderRadius: "32px",
              }}
              trackStyle={{
                backgroundColor: "#5295e0",
                height: "14px",
                borderRadius: "32px",
              }}
              handleStyle={{
                backgroundColor: "#ffffff",
                marginTop: "0px",
                borderRadius: "32px",
                border: "2px solid #5295E0",
              }}
            />
          </div>
        </div>
        <div className={styles.subBox}>
          <span>Subscribe & Save discount</span>
          <div className={styles.subBox__btns}>
            {[5, 10, 15].map((discount) => (
              <button
                key={discount}
                className={classNames(styles.btnSub, {
                  [styles.active]: activeDiscount === discount,
                })}
                onClick={() => handleDiscountClick(discount)}
              >
                {discount}%
              </button>
            ))}
          </div>
        </div>
        <div className={styles.couponBox}>
          <span>Coupon</span>
          <div className={styles.sliderContainer}>
            <div className={styles.inputNumberWithIcon}>
              <InputNumber
                min={0}
                max={100}
                value={couponValue}
                onChange={handleCouponChange}
                className={styles.inputField}
                controls={false}
              />
            </div>
            <Slider
              min={0}
              max={100}
              value={couponValue}
              onChange={handleCouponChange}
              className={styles.customSlider}
              railStyle={{
                backgroundColor: "#2e2e2e",
                height: "14px",
                borderRadius: "32px",
              }}
              trackStyle={{
                backgroundColor: "#5295e0",
                height: "14px",
                borderRadius: "32px",
              }}
              handleStyle={{
                backgroundColor: "#ffffff",
                marginTop: "0px",
                borderRadius: "32px",
                border: "2px solid #5295E0",
              }}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default Pricing;
